export default __webpack_public_path__ + "static/media/Digital Keys.ad524d7b.svg";